/**
 * Converts a JSON object to FormData for workpack requests.
 *
 * @param {Object} json - The JSON object to convert
 * @returns {FormData} - The FormData object ready for submission
 */
export const jsonToFormData = (json = {}) => {
    const formData = new FormData();
    Object.keys(json).forEach(key => {
        switch (key) {
            case 'printSpec':
            case 'geometry':
                formData.append(key, JSON.stringify(json[key]));
                break;
            case 'draft':
            case 'isEmergency':
            case 'created':
            case 'electricityStylingOptIn':
                formData.append(key, json[key] === true ? 'true' : 'false');
                break;
            default:
                formData.append(key, json[key]);
        }
    });
    return formData;
};/**
 * Converts FormData back to a JSON object for workpack requests.
 *
 * @param {FormData} formData - The FormData to convert
 * @returns {Object} - The JSON object
 */
export const formDataToJson = (formData = new FormData()) => {
    const workpack = Object.fromEntries(formData);
    Object.keys(workpack).forEach(key => {
        switch (key) {
            case 'printSpec':
            case 'geometry':
                workpack[key] = JSON.parse(workpack[key]);
                break;
            case 'draft':
            case 'isEmergency':
            case 'created':
            case 'electricityStylingOptIn':
                workpack[key] = (workpack[key] === 'true');
                break;
        }
    });
    return workpack;
};
